var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333496 5.87916C0.333496 2.81258 2.89608 0.333984 5.99579 0.333984C9.10424 0.333984 11.6668 2.81258 11.6668 5.87916C11.6668 7.42444 11.1048 8.85907 10.1798 10.075C9.15937 11.4163 7.9016 12.585 6.48586 13.5023C6.16184 13.7143 5.86941 13.7303 5.5138 13.5023C4.08999 12.585 2.83222 11.4163 1.8205 10.075C0.894818 8.85907 0.333496 7.42444 0.333496 5.87916ZM4.12965 6.05182C4.12965 7.07912 4.96793 7.8871 5.99579 7.8871C7.02432 7.8871 7.87068 7.07912 7.87068 6.05182C7.87068 5.03251 7.02432 4.18521 5.99579 4.18521C4.96793 4.18521 4.12965 5.03251 4.12965 6.05182Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationUpdate);
export default __webpack_public_path__ + "static/media/locationUpdate.ef67e1e8366b3aa112ba55759110b0a5.svg";
export { ForwardRef as ReactComponent };